<template>
  <div class="modal offer-modal skin-modal offer-details-modal">
    <div class="overlay" @click="$emit('closeOfferDetailsModal')"></div>
    <div class="wrapper">
      <img
        class="close"
        @click="$emit('closeOfferDetailsModal')"
        src="./../img/cross.svg"
      />
      <div class="container">
        <form @submit.prevent>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>Details</b>
              </div>
              <div class="form-fields-wrapper">
                <div class="offer-wrapper">
                  <div class="row">
                    <div class="title">Skin name</div>
                    <div class="desc">{{ orderToView.title }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Quality</div>
                    <div class="desc">{{ orderToView.quality }}</div>
                  </div>
                  <div class="row">
                    <div class="title">Desired Price</div>
                    <div class="desc">
                      <b
                        >{{ orderToView.user_price }}
                        {{ orderToView.currency }}</b
                      >
                    </div>
                  </div>
                  <div class="row row-spec">
                    <div class="title">Our price</div>
                    <div class="desc">
                      <b
                        >{{ orderToView.service_price }}
                        {{ orderToView.currency }}</b
                      >
                    </div>
                  </div>
                  <!-- Error Message Display -->
                  <transition name="slide">
                    <div
                      v-if="error"
                      class="error-desc desc red"
                      style="margin-top: 15px"
                    >
                      {{ error }}
                    </div>
                  </transition>
                  <!-- Action Buttons -->
                  <div class="buttons">
                    <div
                      class="button orange-btn"
                      @click="decline"
                      :disabled="isLoading"
                    >
                      <span>{{ isLoading ? "Processing..." : "Decline" }}</span>
                    </div>
                    <div
                      class="button red"
                      @click="accept"
                      :disabled="isLoading"
                    >
                      <span>{{ isLoading ? "Accepting..." : "Accept" }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferDetailsModal",
  props: ["orderToView"],
  data() {
    return {
      isLoading: false,
      error: "",
    };
  },
  methods: {
    handleApiCall(endpoint, successMessage) {
      if (this.isLoading) return;
      this.isLoading = true;
      this.error = "";

      const data = { id: this.orderToView.id };

      this.$http
        .post(process.env.VUE_APP_API + endpoint, data)
        .then(() => {
          console.log(successMessage);
          // Emit a generic event to signal the parent to refresh
          this.$emit("actionCompleted");
          this.$emit("closeOfferDetailsModal");
        })
        .catch((err) => {
          this.error =
            err.response?.data?.message || "An unexpected error occurred.";
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    decline() {
      this.handleApiCall("offer/decline", "Offer declined successfully.");
    },
    accept() {
      this.handleApiCall("offer/accept", "Offer accepted successfully.");
    },
  },
  watch: {
    orderToView() {
      this.error = "";
    },
  },
};
</script>
